export default __webpack_public_path__ + "static/media/blast.2a88dd3b.svg";